import React from 'react';
import { defaultCssVariablesResolver, MantineProvider } from '@mantine/core';
import { mantineTheme } from './theme';

const TEXT_COLOR = '#444b57';

const mergeTheme = (baseTheme, override) => {
  if (!override) {
    return baseTheme;
  }

  return {
    ...baseTheme,
    ...override,
    colors: {
      ...(baseTheme.colors || {}),
      ...(override.colors || {}),
    },
    components: {
      ...(baseTheme.components || {}),
      ...(override.components || {}),
    },
  };
};

export function AppMantineProvider({ children, themeOverride }) {
  const theme = mergeTheme(mantineTheme, themeOverride);
  const cssVariablesResolver = (resolvedTheme) => {
    const variables = defaultCssVariablesResolver(resolvedTheme);

    return {
      ...variables,
      light: {
        ...variables.light,
        '--mantine-color-text': TEXT_COLOR,
      },
    };
  };

  return (
    <MantineProvider theme={theme} defaultColorScheme="light" cssVariablesResolver={cssVariablesResolver}>
      {children}
    </MantineProvider>
  );
}
